import React, { useState }  from "react";
import validator from "validator";
import OkPopup from "../OkPopup";

/*
curl --location --request POST 'https://ws.mediatoys.it/cliente/edit_cliente' \
--header 'Authorization: Bearer {{token}}' \
--header 'Accept: application/json' \
--data-urlencode 'id_e_user=2' \
--data-urlencode 'nome=Gabriele' \
--data-urlencode 'cognome=Franceschi' \
--data-urlencode 'sesso=U' \
--data-urlencode 'data_nascita=463164324' \
--data-urlencode 'cellulare=3281327086' \
--data-urlencode 'id_sessione=dfsffsfs'
*/
const ProfileDati = (props) => {
  const [IsLoading, setIsLoading] = useState(false);
  const [netError, setNetError] = useState(null);
  const [showDialog, setShowDialog] = useState(false)

  const [Nome, setNome] = useState(props.userData.nome);
  const [Cognome, setCognome] = useState(props.userData.cognome);
  const [Cellulare, setCellulare] = useState(props.userData.cellulare);
  const [Credito, setCredito] = useState(null);

  function getClientCredit() {
    let params = [
      { name: "id_e_user", value: props.userData.id_e_user },
    ];
    props.wsCall(
      "https://ws.mediatoys.it/cliente/GetCreditoCliente",
      IsLoading,
      setIsLoading,
      netError,
      setNetError,
      params,
      (respData) => {
        if (respData.id_e_user === props.userData.id_e_user)        
          setCredito(respData.valore_credito);
        else
          // don't show it for privacy reasons
          setCredito(0);
      }
    );
  }

  const submitHandler = (event) => {
    event.preventDefault();
    let params = [
      { name: "id_e_user", value: props.userData.id_e_user },
      { name: "nome", value: Nome },
      { name: "cognome", value: Cognome },
      { name: "cellulare", value: Cellulare },
      { name: "id_sessione", value: props.sessionKey },
    ];
    props.wsCall(
      "https://ws.mediatoys.it/cliente/edit_cliente",
      IsLoading,
      setIsLoading,
      netError,
      setNetError,
      params,
      (result) => {
        props.userUpdate(result.data);
        setShowDialog(true);
      }
    );
  };

  const closeAddedDialog = () => {
    setShowDialog(false);
  }

  if (Credito === null) {
    getClientCredit();
    return (
      <div className="spinner">
        <img src="/images/waiting.gif" alt="loading..." />
      </div>
    );
  }

  return (
    <div className="dati_utente">
      {showDialog ? (
          <OkPopup
            titletext="Operazione completata"
            text="Dati utente modificati correttamente"
            closeHandler={closeAddedDialog}
          />
        ) : null}

      <p>Indirizzo e-mail: <span className="profilo_email_statico">{props.userData.mail}</span></p>
      <p>Credito cliente: <span className="profilo_credito_statico">{props.convert(Credito)} &euro;</span></p>
 
      <form onSubmit={submitHandler}>
        <label htmlFor="nome">Nome</label>
        <input
          id="nome"
          value={Nome}
          onChange={(event) => setNome(event.target.value)}
        ></input>
        <br />
        <br />
        <label htmlFor="cognome">Cognome</label>
        <input
          id="cognome"
          value={Cognome}
          onChange={(event) => setCognome(event.target.value)}
        ></input>
        <br />
        <br />
        <label htmlFor="cellulare">Cellulare</label>
        <input
          id="cellulare"
          value={Cellulare}
          onChange={(event) => setCellulare(event.target.value)}
        ></input>
    
        <br />

        <button type="submit">Applica modifiche</button>
      </form>
    </div>
  );
};

export default ProfileDati;
